module.exports = __webpack_public_path__ + "img/suppliers_report.a811dbf6.png";